/** Customers domain API — tipos puros del dominio, errores y labels. */

export type {
  CustomerAccountListQuery,
  CustomerAccountRow,
  CustomerMovementHistoryFilters,
  CustomerMovementRow,
  CustomerPortalTokenRow,
  CustomerDaySummary,
  CustomerMovementActorOpts,
} from './domain/customerTypes';

export {
  CustomerCreditLimitExceededError,
  CustomerBlockedError,
  CustomerNotFoundError,
  CustomerDomainError,
} from './domain/customerErrors';

export {
  getCustomerMovementTypeLabel,
  getCustomerMovementDisplayLabel,
} from './domain/customerMovementLabels';

export type { CustomerVoidPlan, SaleDetailForCustomerVoidPreview } from './domain/customerVoidPlan';
export { buildCustomerVoidPlanFromSaleDetail } from './domain/customerVoidPlan';
